import { createAsyncThunk } from '@reduxjs/toolkit';
import { IGetLLMTemplateVariablesResponse } from '@/models/llmTemplate.model';
import { IApiError } from '@/models/apiError.model';
import { formatApiError } from '@/utils';
import { LLMTemplateAPI } from '@/api';
import { SLICE_NAME } from './models';

export const getLLMTemplateVariables = createAsyncThunk<
  IGetLLMTemplateVariablesResponse,
  void,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getLLMTemplateVariables`,
  async () => {
    const response = await LLMTemplateAPI.getTemplateVariables();
    return response.data;
  },
  { serializeError: formatApiError },
);
